import React, { useCallback, useMemo, memo } from 'react';

import { Popover } from 'antd';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';

import PropTypesHelper from '../../helpers/proptypes-helper';
import styles from './styles.module.scss';

const ColorPicker = memo(({
    value, onChange, ...others
}) => {
    const handleChange = useCallback(color => {
        onChange(color ? color.hex : null);
    }, [onChange]);
    const color = useMemo(() => ({ hex: value }), [value]);

    const colorStyle = useMemo(() => ({ backgroundColor: color.hex }), [color]);
    return (
        <Popover
            trigger="click"
            placement="bottom"
            content={(
                <SketchPicker
                    disableAlpha
                    {...others}
                    className={styles.sketch}
                    color={color}
                    onChange={handleChange}
                />
            )}
        >
            <button
                className={styles.button}
                type="button"
                title="Clique para selecionar uma cor"
            >
                <span
                    className={styles.color}
                    style={colorStyle}
                />
            </button>
        </Popover>
    );
});

ColorPicker.propTypes = {
    value: PropTypesHelper.color,
    onChange: PropTypes.func,
};

export default ColorPicker;
